export default function StatusBadge({ status }) {
  const statusConfig = {
    Active: {
      container: "bg-green-100 text-green-700",
      dot: "bg-green-500",
    },
    "On Leave": {
      container: "bg-blue-100 text-blue-700",
      dot: "bg-blue-500",
    },
    Inactive: {
      container: "bg-gray-100 text-gray-700",
      dot: "bg-gray-500",
    },
  };

  const currentStatus =
    statusConfig[status] || statusConfig.Inactive;

  return (
    <span
      className={`
        inline-flex
        items-center
        gap-2
        px-3
        py-1
        rounded-full
        text-xs
        font-semibold
        ${currentStatus.container}
      `}
    >
      <span
        className={`
          h-2
          w-2
          rounded-full
          ${currentStatus.dot}
        `}
      />

      {status}
    </span>
  );
}